import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { WHATSAPP, buildWhatsappLink } from "@/lib/config";

const FinalCTA = () => {
  return (
    <section
      id="cta-final"
      className="relative overflow-hidden bg-[#3E2723] py-24 md:py-32"
      data-testid="final-cta-section"
    >
      <div className="pointer-events-none absolute -top-32 -right-32 h-96 w-96 rounded-full bg-[#D4AF37]/15 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-[#D4AF37]/10 blur-3xl" />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="relative mx-auto max-w-4xl px-6 text-center md:px-12"
      >
        <p className="mb-3 text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
          Comece agora
        </p>
        <h2
          className="font-serif text-3xl leading-tight text-[#FDFBF7] sm:text-4xl lg:text-5xl"
          data-testid="final-cta-title"
        >
          Sua transformação pode <br />
          <em className="italic text-[#D4AF37]">começar hoje.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-[#FDFBF7]/75 md:text-lg">
          Agende sua consulta e descubra um caminho mais inteligente para
          cuidar da sua saúde.
        </p>

        <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row sm:flex-wrap">
          <Button
            asChild
            className="rounded-full bg-[#D4AF37] px-8 py-6 text-xs uppercase tracking-[0.25em] text-white hover:bg-[#C5A059]"
            data-testid="final-cta-mogi"
          >
            <a
              href={buildWhatsappLink(WHATSAPP.mogi_guacu)}
              target="_blank"
              rel="noopener noreferrer"
            >
              Mogi Guaçu
            </a>
          </Button>
          <Button
            asChild
            className="rounded-full bg-[#D4AF37] px-8 py-6 text-xs uppercase tracking-[0.25em] text-white hover:bg-[#C5A059]"
            data-testid="final-cta-artur"
          >
            <a
              href={buildWhatsappLink(WHATSAPP.artur_nogueira)}
              target="_blank"
              rel="noopener noreferrer"
            >
              Artur Nogueira
            </a>
          </Button>
          <Button
            asChild
            variant="outline"
            className="rounded-full border-[#D4AF37] bg-transparent px-8 py-6 text-xs uppercase tracking-[0.25em] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white"
            data-testid="final-cta-online"
          >
            <a
              href={buildWhatsappLink(WHATSAPP.online)}
              target="_blank"
              rel="noopener noreferrer"
            >
              Atendimento online
            </a>
          </Button>
        </div>
      </motion.div>
    </section>
  );
};

export default FinalCTA;
